var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolTip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "#00DD97",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17871 10.0781C9.13574 10.2142 9.11247 10.4255 9.10889 10.7119H7.65869C7.68018 10.1068 7.73747 9.68962 7.83057 9.46045C7.92367 9.2277 8.16357 8.96094 8.55029 8.66016L8.94238 8.354C9.07129 8.25732 9.17513 8.15169 9.25391 8.03711C9.39714 7.84017 9.46875 7.62354 9.46875 7.38721C9.46875 7.11507 9.38818 6.868 9.22705 6.646C9.0695 6.42041 8.77946 6.30762 8.35693 6.30762C7.94157 6.30762 7.64616 6.44548 7.4707 6.72119C7.29883 6.99691 7.21289 7.28337 7.21289 7.58057H5.66064C5.70361 6.56006 6.0599 5.83675 6.72949 5.41064C7.15202 5.13851 7.67122 5.00244 8.28711 5.00244C9.09635 5.00244 9.76774 5.1958 10.3013 5.58252C10.8384 5.96924 11.1069 6.54215 11.1069 7.30127C11.1069 7.76676 10.9906 8.15885 10.7578 8.47754C10.6217 8.6709 10.3604 8.91797 9.97363 9.21875L9.59229 9.51416C9.3846 9.67529 9.24674 9.86328 9.17871 10.0781ZM9.22168 13H7.62109V11.4478H9.22168V13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/toolTip.14986904d55d8d6ed35d4da516e213d5.svg";
export { ForwardRef as ReactComponent };